import React from "react";
import { ProjectListCard } from "./ProjectListCard";
import { ProjectListEntry } from "../core/types";

interface ProjectListAppCardsProps {
  projects: ProjectListEntry[];
  onProjectClick: (project: ProjectListEntry) => void;
  onProjectDeleted?: () => void;
}

export const ProjectListAppCards: React.FC<ProjectListAppCardsProps> = ({ projects, onProjectClick, onProjectDeleted }) => {
  return (
    <>
      {projects.map((project) => (
        <ProjectListCard project={project} key={project.id} clicked={onProjectClick} onProjectDeleted={onProjectDeleted} />
      ))}
    </>
  );
};
